export default "__VITE_ASSET__MCYMIxPj__"